import PieceModel from '@/models/piece';
import { PieceTypeModel } from '@/models/piece/piece-type.model';
import { DimensionsModel } from '@/models/piece/dimensions.model';

export default class PieceService {
  // eslint-disable-next-line class-methods-use-this
  getPiece(type, dimensions, weight) {
    return new PieceModel(type, dimensions, weight);
  }

  // eslint-disable-next-line class-methods-use-this
  getPieceType(type) {
    return PieceTypeModel.createPieceTypeModel(type);
  }

  // eslint-disable-next-line class-methods-use-this
  getPieceDimensions(width, height, depth) {
    return new DimensionsModel(width, height, depth);
  }
}
